module.exports = __webpack_public_path__ + "img/iata-logo.f5e5b3ea.png";